import React, { useState } from 'react';
import { Tag, Modal, List } from 'antd';
import { useTranslation } from 'react-i18next';
import { ADOPTION_COLORS } from '../../../../constants/graphColors';
import '../../../../../stylesheets/components/receiver/scorecard.scss';

interface ValidationStatusTagsProps {
  validations: string[];
  displayCount?: number;
}

const ValidationStatusTags: React.FC<ValidationStatusTagsProps> = ({
  validations,
  displayCount = 2,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  if (!validations || validations.length === 0) {
    return (
      <Tag className="validation-status-tag validation-status-tag--complete">
        {t('receiver:allComplete')}
      </Tag>
    );
  }

  const visibleValidations = validations.slice(0, displayCount);
  const remainingCount = validations.length - displayCount;

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCurrentPage(1);
    setPageSize(10);
  };

  return (
    <>
      <div className="validation-status-container">
        {visibleValidations.map((validation, index) => (
          <Tag key={index} className="validation-status-tag validation-status-tag--missing">
            {validation}
          </Tag>
        ))}
        {remainingCount > 0 && (
          <Tag
            className="validation-status-tag validation-status-tag--more"
            onClick={handleOpenModal}
            style={{ cursor: 'pointer' }}
          >
            +{remainingCount} {t('receiver:more')}
          </Tag>
        )}
      </div>

      <Modal
        title={t('receiver:validationsMissing')}
        open={isModalOpen}
        onCancel={handleCloseModal}
        footer={null}
        width={700}
      >
        <List
          dataSource={validations}
          renderItem={validation => (
            <List.Item style={{ padding: '8px 0' }}>
              <div style={{ fontSize: '13px', color: '#262626' }}>{validation}</div>
            </List.Item>
          )}
          pagination={{
            current: currentPage,
            pageSize,
            total: validations.length,
            size: 'small',
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: (page, newPageSize) => {
              setCurrentPage(page);
              if (newPageSize !== pageSize) {
                setPageSize(newPageSize);
                setCurrentPage(1);
              }
            },
          }}
        />
      </Modal>
    </>
  );
};

export default ValidationStatusTags;
